import {
  customInstanceWithHeader,
  type ResponseWithHeaders,
} from '@fukuri-admins/apis/client/base/axiosInstance';
import {
  getGetApiV1ThreeLetterCodeClientAdminsBranchesKey,
  getGetApiV1ThreeLetterCodeClientAdminsBranchesUrl,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type {
  GetApiV1ThreeLetterCodeClientAdminsBranches200,
  GetApiV1ThreeLetterCodeClientAdminsBranchesParams,
} from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';
import type { KeyedMutator } from 'swr';

const fetcher = (
  threeLetterCode: string,
  apiParams: GetApiV1ThreeLetterCodeClientAdminsBranchesParams
) =>
  customInstanceWithHeader<GetApiV1ThreeLetterCodeClientAdminsBranches200>(
    getGetApiV1ThreeLetterCodeClientAdminsBranchesUrl(threeLetterCode, apiParams),
    { method: 'GET' }
  );

type Args = {
  threeLetterCode: string;
  page?: string;
};

type IUseGetBranchList = (args: Args) => {
  data: GetApiV1ThreeLetterCodeClientAdminsBranches200;
  totalPage: number;
  totalCount: number;
  mutate: KeyedMutator<ResponseWithHeaders<GetApiV1ThreeLetterCodeClientAdminsBranches200>>;
};

/**
 * 事業所一覧取得フック
 */
export const useGetBranchList: IUseGetBranchList = ({ threeLetterCode, page }) => {
  const apiParams: GetApiV1ThreeLetterCodeClientAdminsBranchesParams = {
    ...(page && !Number.isNaN(Number(page)) && { page: Number(page) }),
  };

  const { data, mutate } = useFetch<
    ResponseWithHeaders<GetApiV1ThreeLetterCodeClientAdminsBranches200>
  >(
    getGetApiV1ThreeLetterCodeClientAdminsBranchesKey(threeLetterCode, apiParams),
    () => fetcher(threeLetterCode, apiParams),
    { suspense: true }
  );

  const totalPage = Number(data.headers['total-pages']) || 0;
  const totalCount = Number(data.headers['total-count']) || 0;

  return {
    data: data.data,
    totalPage,
    totalCount,
    mutate,
  };
};
